<ng-container *ngIf="tile?.settings?.visualization !== null">
  <div id="chart-{{ tile.id }}" class="chart"></div>
  <div id="legend-{{ tile.id }}" class="custom-legend"></div>
</ng-container>

